import isString from 'lodash-es/isString';

export function keyboardServiceProvider() {
    this.$get = $get;

    $get.$inject = ['$injector'];

    function $get($injector) {
        return $injector.instantiate(KeyboardService);
    }
}

class KeyboardService {
    private keys: Set<any>;

    constructor() {
        this.keys = new Set();

        this._onKeyUp = this._onKeyUp.bind(this);
        this._onKeyDown = this._onKeyDown.bind(this);
        this._onWindowBlur = this._onWindowBlur.bind(this);

        // Add event listeners
        if (window) {
            window.addEventListener('keyup', this._onKeyUp);
            window.addEventListener('keydown', this._onKeyDown);
            window.addEventListener('blur', this._onWindowBlur, false);
        }
    }

    /**
     *
     * @param {(string[]|string)?} keys
     * @returns {*}
     */
    isPressed(keys = undefined) {
        return this.isDown(keys);
    }

    /**
     * @param {(string[]|string)?} keys
     * @returns {boolean}
     */
    isDown(keys = undefined) {
        if (!keys || !keys.length) {
            return this.keys.size > 0;
        }

        if (isString(keys)) {
            keys = [keys];
        }

        return keys.filter(key => this.keys.has(key)).length === keys.length;
    }

    _onWindowBlur() {
        // Remove all keys
        this.keys.clear();
    }

    /**
     * @param {KeyboardEvent} $event
     * @private
     */
    _onKeyDown($event) {
        this.keys.add(_characterFromEvent($event));
    }

    /**
     * @param {KeyboardEvent} $event
     * @private
     */
    _onKeyUp($event) {
        this.keys.delete(_characterFromEvent($event));
    }
}

/**
 * Key codes borrow from https://github.com/ccampbell/mousetrap/blob/master/mousetrap.js
 */
const _MAP = {
    8: 'backspace',
    9: 'tab',
    13: 'enter',
    16: 'shift',
    17: 'ctrl',
    18: 'alt',
    20: 'capslock',
    27: 'esc',
    32: 'space',
    33: 'pageup',
    34: 'pagedown',
    35: 'end',
    36: 'home',
    37: 'left',
    38: 'up',
    39: 'right',
    40: 'down',
    45: 'ins',
    46: 'del',
    91: 'meta',
    93: 'meta',
    224: 'meta',
};

/**
 * mapping for special characters so they can support
 *
 * this dictionary is only used incase you want to bind a
 * keyup or keydown event to one of these keys
 *
 * @type {Object}
 */
const _KEYCODE_MAP = {
    106: '*',
    107: '+',
    109: '-',
    110: '.',
    111: '/',
    186: ';',
    187: '=',
    188: ',',
    189: '-',
    190: '.',
    191: '/',
    192: '`',
    219: '[',
    220: '\\',
    221: ']',
    222: "'",
};

/**
 *
 * @param {KeyboardEvent} $event
 * @returns {*}
 * @private
 */
function _characterFromEvent($event) {
    // for keypress events we should return the character as is
    if ($event.type === 'keypress') {
        let character = String.fromCharCode($event.which);

        if (!$event.shiftKey) {
            character = character.toLowerCase();
        }

        return character;
    }

    // for non keypress events the special maps are needed
    if (_MAP[$event.which]) {
        return _MAP[$event.which];
    }

    if (_KEYCODE_MAP[$event.which]) {
        return _KEYCODE_MAP[$event.which];
    }

    // if it is not in the special map

    // with keydown and keyup events the character seems to always
    // come in as an uppercase character whether you are pressing shift
    // or not.  we should make sure it is always lowercase for comparisons
    return String.fromCharCode($event.which).toLowerCase();
}
